// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"456":"0e055a4c","515":"a43d4067","601":"d5bc5317"}[chunkId] + ".chunk.js";
};